/* ═══════════════════════════════════════════════════════════════════════════════════════════════
   assets/asf-chart-fit-2.js ── CHART 曲行「例外だけ縮小」オートフィッタ（2026-08-05 / 世代 -35）
   ------------------------------------------------------------------------------------------------
   ★ クライアント再裁定（世代 -35・前走 -34 の設計を差し替え）★
     -34 は「はみ出すセルだけ長体（Söhne Schmal Kräftig）へ落とす」だった。
     本走でクライアントが **自動「長体化」を廃止し、自動「縮小」へ** と再裁定した:
       「はみ出すセル（International Deejay Gigolo Records 等）は Buch のまま
         文字サイズを下げて 1 行に収める（この行だけ小さい文字でよい）」
     ＝ 幅（family）で解くのをやめ、級数（font-size）で解く。曲名・レーベルは
       通常幅 Söhne **Buch(400)** のまま、収まる最大サイズまで 0.5px 刻みで下げる。

   ★ 前身 assets/asf-chart-fit-1.js との差分（それ以外の骨格は逐語で同一）★
     ・書くもの … class 'chart-fit--narrow' の付与 → **インラインの font-size**
     ・下限 …… 無し（長体で足りなければ諦める）→ **8px**（下限に達しても収まらなければ
                そこで打ち切り、承認済みの右吊り折返し（K3）に委ねる）
     ・刻み …… 段階なし（通常幅 / 長体の 2 値）→ **0.5px**
     ・不変 …… 測るもの（自然インク幅 / 可用幅）・測り直す契機（タブ遷移 / リサイズ /
                フォント読込）・「長い方のセルから処置する」規則・EPS 0.5px・
                DOM の追加削除ゼロ・文言変更ゼロ。

   ★ 行の骨格は 1px も動かない ★ .t-title / .t-label の line-height は **px 固定（16px）**で、
     行の外形（61px）も padding と row-gap から決まる。font-size を下げても
     行送りも行高もベースライン位置も変わらない ＝ 縮んだセルは隣の行と天地が揃ったまま、
     字面だけが小さくなる（活版で 1 行だけ級数を落とすときの作法と同じ）。

   ★ 既定（Graphik）/ neuedin では 1 バイトも動かない ★ 最初の 1 行で data-font を見て return。
     イベント購読も MutationObserver も ResizeObserver も **登録前に**打ち切る。

   ★ なぜ「解析式で一発」ではなく実測ループなのか ★
     .t-title / .t-label の letter-spacing は em 基準（.01em / .09em）なのでインク幅は
     font-size にほぼ厳密比例し、必要サイズは解析的に出せる。それでも 0.5px ずつ下げて
     **毎回測り直す**のは、ヒンティングとサブピクセル丸めが級数ごとに非線形な段差を作るため
     （実測で最大 0.3px 級）。発動するのは全 60 セル中 1〜2 セルなので、ループの費用は
     1 タブ遷移あたり数十回のレイアウトに過ぎない。

   ★ 触っていないもの ★ 順位 .rank ／ アーティスト名 .t-artist の意匠（14px Kräftig）／
     asf-index.js / GA / 音声層 / 3D（SHOP 軌道）/ 文言 / 行送り / 字間 / padding / 行構造。
   ═══════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var ROOT = document.documentElement;
  if (ROOT.getAttribute('data-font') !== 'soehne') { return; }   /* 既定 / neuedin は即撤退 */

  var EPS = 0.5;          /* サブピクセル丸めの安全代（px）。-34 の判断をそのまま継承 */
  var STEP = 0.5;         /* 級数を下げる刻み（px）。クライアント裁定の明示値 */
  var MIN_FS = 8;         /* 下限（px）。クライアント裁定の明示値 */
  var view = null, pending = false;

  /* 折返しを禁じた状態での自然インク幅（小数精度・Range なので行送りや余白を含まない） */
  function ink(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    return r.getBoundingClientRect().width;
  }
  function baseFS(el) {
    /* インライン指定を外した「CSS が与える本来のサイズ」。測定の初期条件を毎回そこへ戻す。 */
    el.style.fontSize = '';
    return parseFloat(getComputedStyle(el).fontSize) || 12;
  }
  /* 与えられた上限内に収まる **最大の** font-size を 0.5px 刻みで探す。
     戻り値: 採用サイズ（px）。base のままで収まるなら base をそのまま返す。 */
  function shrinkToFit(el, base, limit) {
    var fs = base;
    while (ink(el) > limit - EPS && fs - STEP >= MIN_FS) {
      fs -= STEP;
      el.style.fontSize = fs + 'px';
    }
    return fs;
  }

  function fit() {
    var rows = document.querySelectorAll('#chart .chart-row-compact');
    if (!rows.length) { return; }

    var data = [], i, d, row, a, t, l;

    /* 0) 全セルを「素の級数 + 折返し禁止」へ（測定の初期条件） */
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      a = row.querySelector('.t-artist');
      t = row.querySelector('.t-title');
      l = row.querySelector('.t-label');
      if (!a || !t || !l) { continue; }
      a.style.whiteSpace = 'nowrap'; t.style.whiteSpace = 'nowrap'; l.style.whiteSpace = 'nowrap';
      data.push({ row: row, a: a, t: t, l: l, baseA: baseFS(a), baseT: baseFS(t), baseL: baseFS(l) });
    }
    if (!data.length) { return; }

    /* 1) 可用幅と素のインクを一括採取（レイアウト確定は 1 回） */
    for (i = 0; i < data.length; i++) {
      d = data[i];
      var cs = getComputedStyle(d.row);
      var inner = d.row.getBoundingClientRect().width
                - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var gap = parseFloat(cs.columnGap) || 0;
      var rank = parseFloat(cs.gridTemplateColumns) || 0;
      if (!(inner > 0)) { restore(data); return; }  /* ビュー非表示中（display:none）は測れないので何もしない */
      d.availA = inner - rank - gap;
      d.availTL = inner - rank - gap - gap;
      d.nA = ink(d.a); d.nT = ink(d.t); d.nL = ink(d.l);
    }

    /* 2) 判定して確定 — **長い方のセルから**級数を落とす（-34 の規則をそのまま継承）。
          片方だけで足りなければもう一方も落とす。両方が下限に達したらそこで打ち切り、
          承認済みの右吊り折返し（asf-theme-35.css の K3）に委ねる。 */
    var report = [];
    for (i = 0; i < data.length; i++) {
      d = data[i];
      var fsT = d.baseT, fsL = d.baseL;
      if (d.nT + d.nL > d.availTL - EPS) {
        if (d.nT >= d.nL) {
          fsT = shrinkToFit(d.t, d.baseT, d.availTL - d.nL);
          if (ink(d.t) + d.nL > d.availTL - EPS) { fsL = shrinkToFit(d.l, d.baseL, d.availTL - ink(d.t)); }
        } else {
          fsL = shrinkToFit(d.l, d.baseL, d.availTL - d.nT);
          if (d.nT + ink(d.l) > d.availTL - EPS) { fsT = shrinkToFit(d.t, d.baseT, d.availTL - ink(d.l)); }
        }
      }
      /* アーティスト名は -34 の実測で 4 幅すべて余裕たっぷり（発動 0 件）だが、
         将来メンバーが長い名前を足したときの保険として同じ処方を掛けておく。 */
      var fsA = d.nA > d.availA - EPS ? shrinkToFit(d.a, d.baseA, d.availA) : d.baseA;

      if (fsT !== d.baseT || fsL !== d.baseL || fsA !== d.baseA) {
        report.push({ row: i + 1,
                      artist: fsA !== d.baseA ? fsA : null,
                      title: fsT !== d.baseT ? fsT : null,
                      label: fsL !== d.baseL ? fsL : null });
      }
      d.a.style.whiteSpace = ''; d.t.style.whiteSpace = ''; d.l.style.whiteSpace = '';
    }
    /* 検証用の読み取り専用フック（自動回帰・実測用。挙動には一切影響しない）。 */
    window.ASF_CHART_FIT = { applied: report, width: Math.round(window.innerWidth) };
  }

  function restore(data) {
    for (var i = 0; i < data.length; i++) {
      data[i].a.style.whiteSpace = ''; data[i].t.style.whiteSpace = ''; data[i].l.style.whiteSpace = '';
      data[i].a.style.fontSize = ''; data[i].t.style.fontSize = ''; data[i].l.style.fontSize = '';
    }
  }

  function schedule() {
    if (pending) { return; }
    pending = true;
    requestAnimationFrame(function () { pending = false; fit(); });
  }

  function start() {
    view = document.getElementById('chart');
    if (!view) { return; }
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(view, { attributes: true, attributeFilter: ['class'] });
    }
    if (window.ResizeObserver) { new ResizeObserver(schedule).observe(view); }
    else { window.addEventListener('resize', schedule, { passive: true }); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(schedule); }
    schedule();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
